import App from 'common/backbone-app';
import CHANNEL_CODES from 'config/channelCodes';

// Signup URL must depend on the channel (the marketplace domain we're on),
// not on the UI language. Marketplace pages are organised per channel —
// e.g. www.treatwell.es serves Spanish, www.treatwell.de serves German —
// so the path we hit needs to match the channel we're addressing.
//
// Most channels serve /partners/ (or server-side redirect any historical
// signup paths to it). Two channels do not have /partners/ and need an
// explicit override.
const SIGNUP_PATH_BY_CHANNEL: Record<string, string> = {
  [CHANNEL_CODES.FR]: '/partenaires/',
  [CHANNEL_CODES.LT]: '/partneriai/',
};

const DEFAULT_SIGNUP_PATH = '/partners/';

export function getSignupUrl(): string {
  const path = SIGNUP_PATH_BY_CHANNEL[App.domainChannelCode()] ?? DEFAULT_SIGNUP_PATH;
  return App.getPortalRootUrl() + path;
}
